const MainMenuData = [
	{
		title: 'Applications',
		img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Overview_8b073348-4ffd-45fb-be88-38c79b554653.png?v=1698049935',
		class: 'applications',
		items: [
			{
				url: 'https://ackuretta.com/pages/application-workflow-crown',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4-Workflow_Overview.png?v=1698316732',
				title: 'Crown Workflow',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/application-workflow-splint',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Application_Workflow_Splint.png?v=1705299872',
				title: 'Splint Workflow',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/application-workflow-model',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Application_Workflow_Model.png?v=1705914810',
				title: 'Model Workflow',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/application-workflow-all-on-x',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/All_on_X_icon_2e6f797e-d75b-452b-9675-2f471db99270.png?v=1745995807',
				title: 'All-on-X Workflow',
				readonly: false,
			},
			/*
      {url: '#', img:'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Crown.png?v=1697783613', title:'Crown, Bridge & Veneer', readonly: false},

      {url: '#', img:'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Surgical_Guide.png?v=1697783613', title:'Surgical Guide', readonly: false},
      {url: '#', img:'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Full_Arch_Implant.png?v=1697783613', title:'Full Arch Implant', readonly: false},
      {url: '#', img:'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Denture.png?v=1697783613', title:'Denture', readonly: false},
      {url: '#', img:'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Castable.png?v=1697783613', title:'Castables', readonly: false},
      {url: '#', img:'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_IBT.png?v=1697783613', title:'IBT', readonly: false},
      {url: '#', img:'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Tray.png?v=16977836', title:'Tray', readonly: false},
      */
		],
	},
	// groupsLayout= 0 (default) | 1 (vertical) | 2 (horizontal)
	// https://cdn.ackuretta.com/public/menu/Icons/64x64-transparent.png
	// https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Products.png?v=1697788216
	{
		title: 'Products',
		img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Products.png?v=1697788216',
		hasGroups: true,
		groupsLayout: 1,
		numberOfGroups: 5,
		groupNames: ['3D Printers', 'UV Ovens', 'Washer', 'Resins', 'Accessories'],
		class: 'products',
		items: [
			{
				url: 'https://ackuretta.com/products/sol-plus',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_SOL_Plus.png?v=1707216660',
				title: 'SOL Plus',
				readonly: false,
				itemGroup: 1,
			},
			{
				url: 'https://ackuretta.com/products/sol-dental-3d-printer',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_SOL_42f22b61-0cef-4347-8c7e-dc4068919803.png?v=1699251755',
				title: 'SOL',
				readonly: false,
				itemGroup: 1,
			},
			{
				url: 'https://ackuretta.com/products/dentiq-dental-3d-printer',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_DENTIQ_484db7f2-ce35-42c0-a431-c17f7c94ae4e.png?v=1699251755',
				title: 'DENTIQ',
				readonly: false,
				itemGroup: 1,
			},
			{
				url: 'https://ackuretta.com/products/curie-plus',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Navigation_Bar_Products_CURIE_Plus_NFinity_2159d16e-9415-4167-b992-3b0531406979.png?v=1719990851',
				title: 'CURIE Plus & NFinity',
				readonly: false,
				itemGroup: 2,
			},
			{
				url: 'https://ackuretta.com/products/curie-uv-oven-for-dental-3d-printing',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_CURIE_13abe7ab-4b49-44e9-8de1-d972b000bbb6.png?v=1699251755',
				title: 'CURIE',
				readonly: false,
				itemGroup: 2,
			},
			{
				url: 'https://ackuretta.com/products/uv-box-for-dental-3d-printing',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_CURIE_Plus_c9b05e5e-4701-45ae-94f5-094b8964bc32.png?v=1699251755',
				title: 'UV Box',
				readonly: false,
				itemGroup: 2,
			},
			{
				url: 'https://ackuretta.com/products/cleani-tank-plus',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Tank_Plus.png?v=1707216660',
				title: 'CLEANI with Tank Plus',
				readonly: false,
				itemGroup: 3,
			},
			{
				url: 'https://ackuretta.com/products/cleani-washer-for-dental-3d-printing',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Dual_Tanks.png?v=1707216660',
				title: 'CLEANI with Dual Tanks',
				readonly: false,
				itemGroup: 3,
			},
			{
				url: 'https://ackuretta.com/pages/pac-dent',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Card_Titan.png?v=1711699935',
				title: 'Pac-Dent Resins',
				readonly: false,
				itemGroup: 4,
				onlyIfStoreAvailable: false,
			},
			{
				url: 'https://ackuretta.com/pages/curo-resins',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Resins_e172f900-6bed-48ec-b7fa-3f0d0f9f8cb5.png?v=1699251755',
				title: 'CURO Resins',
				readonly: false,
				itemGroup: 4,
			},
			{
				url: 'https://ackuretta.com/pages/flow-resins-for-dental-3d-printed-applications',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/FLOW_Menu_Bar_Thumbnail.png?v=1714631029',
				title: 'FLOW Resins',
				readonly: false,
				itemGroup: 4,
			},
			{
				url: 'https://ackuretta.com/pages/sol-build-platforms',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_BPs.png?v=1703752449',
				title: 'SOL Build Platforms',
				readonly: false,
				itemGroup: 5,
			},
			{
				url: 'https://ackuretta.com/pages/store?collection=shop-consumables#shop-product-anchor',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Vat.png?v=1703752449',
				title: 'Other Accessories',
				readonly: false,
				itemGroup: 5,
				onlyIfStoreAvailable: true,
			},
		],
	},

	{
		title: 'Services',
		img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Services.png?v=1697788216',
		class: 'services',
		items: [
			{
				url: 'https://ackuretta.com/pages/ackuretta-concierge',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Ackuretta_Concierge.png?v=1697951336',
				title: 'Ackuretta Concierge',
				readonly: false,
			},
			{
				url: '',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/extended-concierge-icon.png?v=1735026128',
				title: 'Extended Coverage',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/personalized-training',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Personalized_Training.png?v=1697951336',
				title: 'Personalized Training',
				readonly: false,
				hideItemInCountries: ['US', 'CA'],
			},
			// keep lease program link in case any retrieval request
			// {
			// 	url: 'https://go.ackuretta.com/sol-lease-program/downloads',
			// 	img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_SOL_Lease_Program.png?v=1697951335',
			// 	title: 'Lease Program',
			// 	readonly: false,
			// 	target: '_blank',
			// 	hideItemInCountries: ['US', 'CA', 'CN', 'RU'],
			// },
			{
				url: 'https://go.ackuretta.com/verieko-conversion',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_VeriEKO.png?v=1715160762',
				title: 'VeriEko Conversion',
				readonly: false,
				target: '_blank',
			},
		],
	},

	{
		title: 'Software',
		img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Software.png?v=1697788217',
		class: 'software',
		items: [
			{
				url: 'https://ackuretta.com/pages/alpha-ai-slicing-software-for-dental-3d-printing',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4-ALPHA_AI_63896cc6-4041-4bc4-9698-72520f1c61ef.png?v=1698044468',
				title: 'Slicing Software',
				readonly: false,
			},
		],
	},

	{
		title: 'Resources',
		img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Resources.png?v=1697788217',
		class: 'resources',
		items: [
			{
				url: 'https://ackuretta.com/blogs/news',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Articles.png?v=1705042615',
				title: 'Articles',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/blogs/press-releases',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Articles___Press_Releases.png?v=1697951345',
				title: 'Press Releases',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/video-gallery',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Video_Gallery_f646518e-1e15-493d-92ff-e386a82ce15c.png?v=1698044469',
				title: 'Video Gallery',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/events',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Events_c61b5e4d-2682-44f6-9f99-9335a502276b.png?v=1698395578',
				title: 'Events',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/newsletter',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Subscribe_to_Newsletter_baba062c-05bd-46f3-b486-0c1389993f24.png?v=1698316436',
				title: 'Subscribe to Newsletter',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/downloads',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Downloadables.png?v=1697951345',
				title: 'Downloadables',
				readonly: false,
			},
		],
	},

	{
		title: 'Partners',
		img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Partners___Distributors_0673fe7f-34b8-49d6-b76a-a4c1ffa13817.png?v=1698044469',
		class: 'partners',
		items: [
			{
				url: 'https://ackuretta.com/account/login',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Distributor_dashboard_32c4d497-046a-441e-9808-b2772a0cf154.png?v=1698316436',
				title: 'Distributor Dashboard',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/partner-and-distributors',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Partners___Distributors_4fc0533d-f9c7-4ed4-8a2c-0788fd65bc81.png?v=1697951368',
				title: 'Partner & Distributors',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/tech-support-ticket',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Support.png?v=1697788217',
				title: 'Tech Support Ticket',
				readonly: false,
			},
			{
				url: 'https://info.ackuretta.com/',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Help_Center.png?v=1697951375',
				title: 'Help Center',
				readonly: false,
				target: '_blank',
				url: 'https://ackuretta.com/pages/become-our-distributor',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Become_Our_Distributors.png?v=1697951368',
				title: 'Become our Distributor',
				readonly: false,
			},
			{
				url: 'https://ackuretta.com/pages/partner-with-us',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Partner_with_Us.png?v=1697951368',
				title: 'Partner With Us',
				readonly: false,
			},
		],
	},

	{
		title: 'Support',
		img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Tech_Support_Ticket.png?v=1697951374',
		class: 'support',
		items: [
			{
				url: 'https://dashboard.ackuretta.com/',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_User_dashboard_0daf0ea9-0eab-418f-9979-49c1d53d9bfa.png?v=1698044468',
				title: 'User Dashboard',
				readonly: false,
				target: '_blank',
			},
			{
				// url: 'https://ackuretta.com/pages/tech-support-ticket',
				url: 'https://dashboard.ackuretta.com/dashboard/support',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Support.png?v=1697788217',
				title: 'Tech Support Ticket',
				readonly: false,
			},
			{
				url: 'https://info.ackuretta.com/',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Help_Center.png?v=1697951375',
				title: 'Help Center',
				readonly: false,
				target: '_blank',
			},
		],
	},

	// { title: 'Contact', img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Contact.png?v=1697788216', items:
	// [
	//   {url: '#', img:'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4-Contact.png?v=1697951380', title:'Contact a Dental Specialist', readonly: false},
	// ]
	// }
];
